import React from 'react';
import moment from 'moment';

export default ({ value }) => {
  return <>{value.deliveryTime ? moment(value.deliveryTime).fromNow() : ''}</>;
};
